import styled from 'styled-components';

export const OrderStyled = styled.div`
    width: 100%;
    min-height: 100%;
    background-color: #F3F3F6;
    display: flex;
    align-items: center;
    flex-direction: column;
`;

export const OrderHeader = styled.div`
    height: 60px;
    display: flex;
    justify-content: flex-start;
    padding-top: 20px;
    max-width: 848px;
    width: 414px;
`;

export const OrderContentCenter = styled.div`
    display: flex;
    align-items: center;
    max-width: 848px;
    flex-direction: column;
    width: 100%;

    @media all and (min-width: 768px) {
        width: 414px;
    }
`;

export const OrderTitle = styled.div`
    color: #14213D;
    font-size: 30px;
    line-height: 22px;
    font-weight: 500;
    width: 100%;
    margin: 30px 0;
    padding-left: 8px;
`;

export const OrderBackdrop = styled.div`
    width: calc(100% - 20px);
    background-color: #fff;
    padding: 22px 16px;
    border-radius: 10px;
`;

export const OrderShopName = styled.div`
    font-size: 18px;
    font-weight: 500;
    color: #14213D;
    margin-bottom: 20px;
`;

export const OrderAmountWrapper = styled.div`
    position: relative;
    margin-bottom: 20px;
`;

export const OrderAmountInput = styled.input`
    width: 100%;
    padding: 14px 16px;
    padding-right: 36px;
    font-size: 18px;
    border: 1px solid #E0E0E0;
    border-radius: 8px;
    outline: none;
    box-sizing: border-box;

    &:focus {
        border-color: #14213D;
    }

    &::placeholder {
        color: #999;
    }
`;

export const OrderAmountSuffix = styled.span`
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 18px;
    color: #999;
    pointer-events: none;
`;

export const OrderPayButton = styled.button`
    width: 100%;
    padding: 16px;
    font-size: 18px;
    font-weight: 500;
    color: #fff;
    background-color: #14213D;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover {
        opacity: 0.9;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export const OrderLoaderWrapper = styled.div`
    width: calc(100% - 20px);
    background-color: #fff;
    padding: 22px 16px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const OrderFooterCopyright = styled.div`
    margin-top: 32px;
    font-size: 12px;
    text-align: center;
    font-weight: 500;
    margin-bottom: 20px;
    padding: 0 24px;
`;

export const OrderError = styled.div`
    color: #b31b1b;
    margin-top: 8px;
    text-align: center;
`;

export const OrderPaymentButtons = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 4px;
`;

const OrderPayButtonBase = styled.button`
    width: 100%;
    height: 56px;
    font-size: 18px;
    font-weight: 500;
    color: #fff;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: opacity 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    &:hover {
        opacity: 0.9;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export const OrderSbpButton = styled(OrderPayButtonBase)`
    background-color: #2A0856;
`;

export const OrderSberPayButton = styled(OrderPayButtonBase)`
    background-color: #21A038;
    font-weight: 600;
`;
